import React, { Component } from "react";
import { Row, Button } from "reactstrap";
import { connect } from "react-redux";
import lodash_map from "lodash/map";
import { loadFilter, searchSites, fetchCustomPoiData, changeLoaderStatus,fetchCompetitionData, 
		fetchDistinctBrands,resetPoiData } from "../../actions/filterActions";
import { mapIconsText } from "../../../map_icons_text";
import M from "materialize-css";
import { setCurrentRoute } from '../../actions/authActions';
import _ from 'lodash';
import InputRange from 'react-input-range';
import "react-input-range/lib/css/index.css";
import Select from 'react-select';

class Filter extends Component {
	state = {
		map_icons: mapIconsText,
		selectedFiletrValues: {},
		selectedNearby:[],
		selectedCompetition:[],
		selectedSECs:[],
		selectedGenders:[],
		ageVal: { min: 20, max: 40 },
	};

	componentWillMount() {
		const { loadFilter, fetchDistinctBrands } = this.props;
		loadFilter();
		fetchDistinctBrands();
	}

	componentWillReceiveProps(nextProp) {
		const { filter_values } = nextProp;
		const filter_keys = Object.keys(filter_values);
		let { selectedFiletrValues } = this.state;
		filter_keys.map(item => {
			if (!selectedFiletrValues[item]){
				selectedFiletrValues[item] = []
			}
			return null;
		});
		this.setState({ selectedFiletrValues });
	}

	componentDidMount(){
		M.AutoInit();
	}


	handleFilterValuesChangeChange = (filter_type, selectedValues) => {
		let { selectedFiletrValues } = this.state;
		selectedFiletrValues[filter_type] = selectedValues;
		this.setState({ selectedFiletrValues });
		const { loadFilter,fetchDistinctBrands } = this.props;
		loadFilter(selectedFiletrValues);
		fetchDistinctBrands(selectedFiletrValues);
		// this.handleFindSites();
		// this.props.drawShapeCity(selectedFiletrValues);
		
	};

	handleFindSites = () => {
		const { selectedFiletrValues } = this.state;
		const { searchSites } = this.props;
		searchSites(selectedFiletrValues);
		const { changeLoaderStatus } = this.props;
		changeLoaderStatus(true);
	};

	nearbyChange = (name,e) => {
		console.log('hola',e.target.checked,'   name',name);
		// When checkbox is checked
		const selectedNearby  = this.state.selectedNearby;
		var modifiedNearby = [];
		if(e.target.checked){
			modifiedNearby = selectedNearby.concat(name);
		}else{
			modifiedNearby = _.filter(selectedNearby,(nb) => {return nb!==name });
		}

		this.setState({selectedNearby: modifiedNearby});
		const { selectedFiletrValues } = this.state;
		const { fetchCustomPoiData,changeLoaderStatus,fetchDistinctBrands,resetPoiData } = this.props;
		
			// request Api for Nearby Data
		if(modifiedNearby.length>0){
			changeLoaderStatus(true);
			fetchCustomPoiData(selectedFiletrValues, [name]);
			fetchDistinctBrands(selectedFiletrValues);
		} else {
			console.log('No Data')
			resetPoiData();
		}
	}


	competitionChange = (val) => {
			// When checkbox is checked
			console.log('name',val)
		this.setState({selectedCompetition: val});
		const { selectedFiletrValues } = this.state;
		const { fetchCompetitionData,changeLoaderStatus } = this.props;
		
			// request Api for Nearby Data
			console.log('modifiedCompetition',modifiedCompetition)
			var modifiedCompetition = val.map((u) => u.value)
		if(modifiedCompetition.length>0){
			changeLoaderStatus(true);
			fetchCompetitionData(selectedFiletrValues, modifiedCompetition);
		} else {
			console.log('No Data')
		}
	}


	secGroupChange = (name,e) => {
		console.log('name',name)
		const selectedSECs  = this.state.selectedSECs;
		var modifiedSECs = [];
		if(e.target.checked){
			modifiedSECs = selectedSECs.concat(name);
		}else{
			modifiedSECs = _.filter(selectedSECs,(nb) => {return nb!==name });
		}

		this.setState({selectedSECs: modifiedSECs});
		const { selectedFiletrValues } = this.state;
		const { changeLoaderStatus,searchSites,fetchDistinctBrands } = this.props;
		
			// request Api for Nearby Data
			console.log('modifiedSec',modifiedSECs)
		if(modifiedSECs.length>0){
			selectedFiletrValues.sec_classification = modifiedSECs.map((o) => { return {label:o,value:o}});
			console.log('selectedFiletrValues',selectedFiletrValues)
			searchSites(selectedFiletrValues);
			changeLoaderStatus(true);
			fetchDistinctBrands(selectedFiletrValues);
		} else {
			console.log('No Data')
		}
	}

	handleAgeChange = (val,e) => {
		console.log('age',val)
		this.setState({ageVal: val});
		const { selectedFiletrValues } = this.state;
		const { changeLoaderStatus,searchSites,fetchDistinctBrands } = this.props;
		
			// request Api for Nearby Data
			selectedFiletrValues.aud_age = val;
			console.log('selectedFiletrValues',selectedFiletrValues)
			searchSites(selectedFiletrValues);
			changeLoaderStatus(true);
			fetchDistinctBrands(selectedFiletrValues);

	}

	genderChange = (name,e) => {
		console.log('name',name)
		const selectedGenders  = this.state.selectedGenders;
		var modifiedGenders = [];
		if(e.target.checked){
			modifiedGenders = selectedGenders.concat(name);
		}else{
			modifiedGenders = _.filter(selectedGenders,(nb) => {return nb!==name });
		}

		this.setState({selectedGenders: modifiedGenders});
		const { selectedFiletrValues } = this.state;
		const { changeLoaderStatus,searchSites,fetchDistinctBrands } = this.props;
		
			// request Api for Nearby Data
			console.log('modifiedSec',modifiedGenders)
		if(modifiedGenders.length>0){
			selectedFiletrValues.aud_gender = modifiedGenders.map((o) => { return {label:o,value:o}});
			console.log('selectedFiletrValues',selectedFiletrValues)
			searchSites(selectedFiletrValues);
			changeLoaderStatus(true);
			fetchDistinctBrands(selectedFiletrValues);
		} else {
			console.log('No Data')
		}
	}


	populationChange = (e) => {
		console.log('plotting')
		this.props.drawWardShape('population');
	}

	employmentChange = (e) => {
		this.props.drawWardShape('employment');
	}

	literacyChange = (e) => {
		this.props.drawWardShape('literacy');
	}

	render() {
		const { filter_values } = this.props;
		const { searchDataCount } = this.props;
		const { distinctBrands } = this.props;
		//console.log('filter_values',filter_values,' searchDataCount',searchDataCount)
		const { selectedFiletrValues, selectedCompetition } = this.state;
		var nearby= [
						{label:'School',value:'school'},{label:'Railway Station',value:'train_station'},
						{label:'Shoe Store',value:'shoe_store'},{label:'Shopping Mall',value:'shopping_mall'},
						{label:'Hospital',value:'hospital'}];

		


		var competition = [];
		if(distinctBrands){
			competition = distinctBrands.map((i) => { return {label:i, value:i}});
		}

		// competition.map((c,i) => {
								
		// 	return <label style={{display:"block"}} key={i}>
		// 			<input type="checkbox" className="filled-in" onChange = {this.competitionChange.bind(this,c.value)} />
		// 			<span style={{color:"#333"}}>{c.label}</span>
		// 		</label>
		// })

		
		
		const sec_groups = [{label:'SEC A', value:'A'},{label:'SEC B', value:'B'},{label:'SEC C', value:'C'},{label:'SEC D', value:'D'}];
		const genders = [{label:'Male',value:'Male'},{label:'Female',value:'Female'}]
		//console.log('filter',filter_values, ' selectedNearby', this.state.selectedNearby)
		console.log('props',this.props)
		var user_email = localStorage.getItem("user");
		
		if(user_email=="acc@admin.com"){
			nearby = [{label:'Gold Counter Asansol',value:'Gold Counter Asansol'},
			{label:'Gold Counter Kolkata',value:'Gold Counter Kolkata'}]
		}
		

		return (
			<div>
				
        
				<Row style={{ width: 300, margin: 10 }}>
				<ul className="collapsible" style={{width:"100%"}}>

					{
						user_email !="acc@admin.com" &&
					
					<li>
					<div className="collapsible-header"><i className="material-icons">filter_drama</i>Find Sites
					 {searchDataCount!==0 && searchDataCount &&
						 <span style={{marginLeft:"10px", fontWeight:"bold"}}> ({searchDataCount}) </span>
						}
					 </div>
					<div className="collapsible-body" style={{padding:"1rem", background:"white"}}>
					{lodash_map(
						filter_values,
						(filter_item_values_array, filter_type) => {
							// if(filter_type==='city'){
							// 	filter_item_values_array = ['Delhi','New Delhi']
							// }
							const filterOptions = filter_item_values_array.map(item => {
								return { value: item, label: item };
							});
							return (
								<Select
									key={filter_type}
									placeholder={"Select " + filter_type}
									name={filter_type}
									value={selectedFiletrValues[filter_type]}
									multi
									onChange={this.handleFilterValuesChangeChange.bind(
										this,
										filter_type
									)}
									options={filterOptions}
									className=" m-1"
								/>
							);
						}
					)}
					<Button
						block
						color="success"
						className="m-1 text-center"
						onClick={this.handleFindSites.bind(this)}
					>
						Find Sites
					</Button>
					</div>
					</li>
				}

					{	
							user_email !="acc@admin.com" &&
											<li>
											<div className="collapsible-header" ><i className="material-icons">attach_money</i>SEC</div>
											<div className="collapsible-body" style={{ background:"white"}}>
												
											{
													sec_groups.map((c,i) => {
														return <label style={{display:"block"}} key={i}>
																<input type="checkbox" className="filled-in" onChange = {this.secGroupChange.bind(this,c.value)} />
																<span style={{color:"#333"}}>{c.label}</span>
															</label>
													})
												}
											</div>
											</li>
					}
	
					
					{ user_email !="acc@admin.com" &&
							<li>
							<div className="collapsible-header" ><i className="material-icons">wc</i>Gender</div>
							<div className="collapsible-body" style={{ background:"white"}}>
								
							{
									genders.map((c,i) => {
										return <label style={{display:"block"}} key={i}>
												<input type="checkbox" className="filled-in" onChange = {this.genderChange.bind(this,c.value)} />
												<span style={{color:"#333"}}>{c.label}</span>
											</label>
									})
								}
							</div>
							</li> }

					
					{user_email !="acc@admin.com" &&
					 <li>
					<div className="collapsible-header" ><i className="material-icons">face</i>Age Group</div>
					<div className="collapsible-body" style={{ background:"white"}}>
						
					<InputRange
						maxValue={60}
						minValue={1}
						value={this.state.ageVal}
						onChange={this.handleAgeChange.bind(this)} />
							
					</div>
					</li>
					 }

	

					<li>
					<div className="collapsible-header" ><i className="material-icons">place</i>POI</div>
					<div className="collapsible-body" style={{ background:"white"}}>
						{
							nearby.map((nb,i) => {
								return <label style={{display:"block"}} key={i}>
										<input type="checkbox" className="filled-in" onChange={this.nearbyChange.bind(this,nb.value)}/>
										<span style={{color:"#333"}}>{nb.label}</span>
									</label>
							})
						}

					</div>
					</li>


					{user_email !="acc@admin.com" &&
					 <li>
					<div className="collapsible-header" ><i className="material-icons">whatshot</i>Competition</div>
					<div className="collapsible-body" style={{ background:"white"}}>
						{
				
							<Select
								multi={true}
								value={selectedCompetition}
								onChange={this.competitionChange.bind(this)}
								options={competition}
								/>
						}
						
						{	
							this.state.selectedCompetition.map((c,i) => {
								return <p style={{fontSize:"13px",marginTop:"5px",marginBottom:"0px",textAlign:"left",fontWeight:"600"}}>{c.label} - {i+1}</p>
							})
									
						}
					

					</div>
					</li> 
					
					}


					{/* <li>
					<div className="collapsible-header" ><i className="material-icons">layers</i>Demographics</div>
					<div className="collapsible-body" style={{ background:"white"}}>
						
									<label style={{display:"block"}}>
										<input name="group1" type="radio" onChange = {this.populationChange.bind(this)} />
										<span>Population Density</span>
									</label>
									<label style={{display:"block"}}>
										<input name="group1" type="radio" onChange = {this.employmentChange.bind(this)} />
										<span>Employment</span>
									</label>
									<label style={{display:"block"}}>
										<input name="group1" type="radio" onChange = {this.literacyChange.bind(this)} />
										<span>Literacy</span>
									</label>
					</div>
					</li> */}

					
					{/* 
					<li>
					<div className="collapsible-header" onClick={this.props.setCurrentRoute.bind(this, "locate_sites")}><i className="material-icons">place</i>Locate Sites</div>
					<div className="collapsible-body">

					</div>
					</li> } */}


					{user_email !="acc@admin.com" &&
					<li>
					<div className="collapsible-header" onClick={this.props.setCurrentRoute.bind(this, "show_created_campaign")}><i className="material-icons">line_style</i>Show Campaigns</div>
					<div className="collapsible-body">

					</div> 
					</li> }


				</ul>

				</Row>
			</div>
		);
	}
}

const mapStateToProps = ({ filter }) => {
	// console.log(filter);
	const { filter_values } = filter;
	const { searchDataCount } = filter;
	const { distinctBrands } = filter;
	const { user } = filter;
	return {
		filter_values,
		searchDataCount,
		distinctBrands,
		user
	};
};

export default connect(
	mapStateToProps,
	{ loadFilter, searchSites, setCurrentRoute,fetchCustomPoiData, changeLoaderStatus,fetchCompetitionData,fetchDistinctBrands,resetPoiData }
)(Filter);



// WEBPACK FOOTER //
// ./src/v3/components/createCampaign/filter.js